import type { SelectedTopFilters } from '@pcln/horizon-search-form'

/** Amenity chip key for the Pet-friendly listings filter (matches top-amenities PETALLOW). */
export const PET_FRIENDLY_AMENITY_FILTER = 'amenities_PETALLOW_Pet friendly' as const

/** SETI experiment for the Pet-friendly toggle in hotel traveler selection (USB-5239). */
export const PET_FRIENDLY_TOGGLE_SETI = 'USB_PET_FRIENDLY_HOTEL_DESKTOP_MWEB'

export type ApplyPetFriendlyToTopFiltersParams = {
  selectedTopFilters: SelectedTopFilters
  petFriendly?: boolean
}

/**
 * When petFriendly is true, returns a copy of selectedTopFilters with PETALLOW
 * added to amenities (deduped if already present). Otherwise returns the input as-is.
 */
export function applyPetFriendlyToTopFilters({
  selectedTopFilters,
  petFriendly,
}: ApplyPetFriendlyToTopFiltersParams): SelectedTopFilters {
  if (!petFriendly) {
    return selectedTopFilters
  }

  return {
    ...selectedTopFilters,
    amenities: new Set([...selectedTopFilters.amenities, PET_FRIENDLY_AMENITY_FILTER]),
  }
}
